import React from 'react';
import { ChannelsPageLayoutHeaderContextType } from './channelsPageLayoutTypes';

const initialContextValue = {
  pageTitle: '',
  setPageTitle: () => null,
  searchTerm: '',
  setSearchTerm: () => null,
  onCreateButtonClick: () => null,
  createButtonProps: {},
  setCreateButtonProps: () => null,
  channelNewButtonProps: {},
  setChannelNewButtonProps: () => null,
  activeChannelTitle: '',
  setActiveChannelTitle: () => null,
  channelHeaderActions: [],
  setChannelHeaderActions: () => null,
  channelHeaderMenuAnchorEl: null,
  setChannelHeaderMenuAnchorEl: () => null,
  setChannelsListToolbarHidden: () => null,
  channelsListToolbarHidden: false,
};

export const ChannelsPageLayoutHeaderContext = React.createContext<
  ChannelsPageLayoutHeaderContextType
>(initialContextValue);
